import { isSetupRevisionSettled } from './revisionState';
import type { SetupRevisionStatus } from './revisionState';

export interface VerifiedRevisionInput {
  setupRevisionId: number;
  setupRevisionStatus: SetupRevisionStatus;
  verifiedSetupFingerprint: string | null;
  /** The profile the verified setup was read back from, if any. */
  activeProfileKey: string | null;
}

const UnscopedProfile = 'unscoped';

/**
 * Names the setup revision downstream caches are allowed to trust.
 *
 * `null` means "nothing is verified right now" - the revision is still in
 * flight, was reopened, or needs recovery. Every consumer that keys a cache on
 * this token therefore recomputes both when a revision opens and when it
 * settles on a new fingerprint.
 */
export const resolveVerifiedRevisionToken = ({
  setupRevisionId,
  setupRevisionStatus,
  verifiedSetupFingerprint,
  activeProfileKey,
}: VerifiedRevisionInput): string | null => {
  if (!isSetupRevisionSettled(setupRevisionStatus) || !verifiedSetupFingerprint) {
    return null;
  }
  return `sr${setupRevisionId}/${verifiedSetupFingerprint}/${activeProfileKey || UnscopedProfile}`;
};
